export type CompanyUser = {
  id: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string | null;
  account_type?: string;
};

export type CompanyUsersPageResponse = {
  current_page: number;
  data: CompanyUser[];
  last_page: number;
  per_page: string | number;
  total: number;
};

export function parseCompanyUsersResponse(response: unknown): CompanyUser[] {
  if (Array.isArray(response)) {
    return response.filter(isCompanyPassengerUser);
  }

  const page = response as CompanyUsersPageResponse;
  if (!Array.isArray(page?.data)) {
    return [];
  }

  return page.data.filter(isCompanyPassengerUser);
}

export function isCompanyPassengerUser(user: CompanyUser): boolean {
  if (!user?.id) return false;
  if (!user.account_type) return true;
  return user.account_type === "user";
}

export function formatCompanyUserLabel(user: CompanyUser): string {
  const name = `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim() || `User #${user.id}`;
  const phone = user.phone?.trim();

  if (phone) {
    return `${user.id} · ${name} · ${phone}`;
  }

  return `${user.id} · ${name}`;
}

export function findCompanyUserById(users: CompanyUser[], userId: number): CompanyUser | undefined {
  return users.find((user) => user.id === userId);
}
